import React, { PureComponent } from 'react'
import { StickyTable, Row, Cell } from 'react-sticky-table'
import { string, bool, func, any, arrayOf, shape } from 'prop-types'
import { RTableHeader } from './RTableHeader'
import { RTableCell } from './RTableCell'

import './RTableSticky.css'

export class RTableSticky extends PureComponent {
    static propTypes = {
        columns: arrayOf(shape({
            key: string.isRequired,
            type: string.isRequired,
            value: any,
        })).isRequired,
        items: arrayOf(shape({
            key: string.isRequired,
            type: string,
            value: any,
        })).isRequired,
        stripped: bool,
        innerBordered: bool,
        noResults: string,
        onRowClick: func,
    }
    static defaultProps = {
        stripped: false,
        innerBordered: false,
        noResults: undefined,
        onRowClick: undefined,
    }

    renderColumnHeader = ({ key, value, cellProps, ...headerCellProps }, colIndex) => {
        const { columns } = this.props
        const headerProps = {
            ...headerCellProps,
            ...(typeof value === 'object' ? value : { value }),
            isFirstColumn: colIndex === 0,
            isLastColumn: colIndex === columns.length - 1
        }
        return <Cell key={key}><RTableHeader {...headerProps} /></Cell>
    }

    renderRow = (item, rowIndex) => {
        const { columns, items, stripped, innerBordered, onRowClick } = this.props
        const { rowProps: { className: rowCellClassName, ...rowData } = {} } = item
        const strippedClass = stripped ? (rowIndex % 2 === 0 ? 'odd' : 'even') : '' // eslint-disable-line no-nested-ternary
        const bottomBordered = innerBordered && rowIndex < items.length - 1
        const cells = columns.map(({ key, cellProps: { className: columnCellClassName, value: getCellValue, ...columnCellProps } = {} }) => ({
            key,
            rowIndex,
            value: item[key] === undefined && getCellValue ? getCellValue(item) : item[key],
            className: `${columnCellClassName || ''} ${rowCellClassName || ''} ${strippedClass || ''}`.trim(),
            bottomBordered,
            ...rowData,
            ...columnCellProps
        }))
        const onClick = onRowClick ? (() => onRowClick({ rowData: item })) : null
        return (
            <Row key={rowIndex} className={['RTable-Row', { onClick: !!onClick }]} onClick={onClick}>
                {cells.map(this.renderCell)}
            </Row>
        )
    }

    renderCell = ({ key, value, ...otherProps }, colIndex) => {
        const { columns } = this.props
        const cellProps = {
            column: key,
            ...otherProps,
            value,
            isFirstColumn: colIndex === 0,
            isLastColumn: colIndex === columns.length - 1
        }
        return <Cell key={key}><RTableCell {...cellProps} /></Cell>
    }


    render() {
        const { items, columns, noResults, className, ...otherProps } = this.props

        return (
            <div className={['RTableStickyContainer', className]}>
                {(items && items.length > 0) && (
                    <StickyTable className="RTableSticky" stickyColumnCount={0} {...otherProps}>
                        <Row>
                            {columns.map(this.renderColumnHeader)}
                        </Row>
                        {items.map(this.renderRow)}
                    </StickyTable>
                )}
                {((!items || items.length === 0) && noResults) && <div className="mt-5 mb-5 text-center">{noResults}</div>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/RTable/RTableSticky.js